export default "__VITE_ASSET__EY1rdtwS__"